module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28207",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9438",
      "ably-hubspot-js": "static-2.4476",
      "atom": "static-1.4832",
      "conversations-async-data": "static-2.7422",
      "conversations-error-reporting": "static-1.8638",
      "conversations-internal-pub-sub": "static-1.15723",
      "conversations-internal-schema": "static-1.12417",
      "conversations-message-history": "static-1.11916",
      "conversations-test-sdk": "static-1.10259",
      "conversations-visitor-experience-components": "static-1.21570",
      "head-dlb": "static-1.4754",
      "hs-promise-utils": "static-1.5352",
      "hs-test-utils": "static-1.7766",
      "hubspot-dlb": "static-2.1796",
      "HubStyleTokens": "static-2.11183",
      "I18n": "static-7.1558",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2780",
      "jasmine-runner": "static-1.6235",
      "quartz": "static-1.6676",
      "react-dlb": "static-1.71",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.59",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4236",
      "StyleGuideUI": "static-3.483",
      "transmute": "static-2.85",
      "urlinator": "static-1.4294",
      "usage-tracker": "static-1.7095",
      "usage-tracker-core": "static-1.6945",
      "usage-tracker-public": "static-1.6906",
      "viral-links-lib": "static-1.6788",
      "visitor-ui-component-library": "static-1.5891",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4572",
      "conversations-prop-types": "static-1.7212",
      "conversations-visitor-message-history": "static-1.20307",
      "cssUtils": "static-1.720",
      "enviro": "static-4.387",
      "flux-actions": "static-1.302",
      "foundations-components": "static-1.7440",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5966",
      "hubspot-url-utils": "static-1.3917",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9391",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.349",
      "raven": "static-3.5624",
      "react": "static-7.177",
      "react-aria": "static-1.60",
      "react-dom": "static-7.85",
      "react-redux": "static-7.66",
      "react-rhumb": "static-1.16402",
      "react-utils": "static-2.5139",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7901",
      "signup-constants": "static-1.18308",
      "styled-components": "static-2.84",
      "usage-tracker-multi": "static-1.5509",
      "visitor-ui-component-library-icons": "static-1.5702",
      "hs-promise-rejection-tracking": "static-1.5291",
      "raven-hubspot": "static-1.5931",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3192",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.80",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.76",
      "quartz-config": "static-1.454",
      "quartz-core": "static-1.5895",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4593",
      "foundations-theming": "static-1.4170",
      "UIComponents": "static-3.8130",
      "customer-data-email": "static-1.17601",
      "cv-backend-services": "static-1.1484",
      "immutable-less": "static-1.4415",
      "conversations-skeleton-state": "static-1.7011",
      "crm-events-viz-core": "static-1.32315",
      "customer-agent-discovery-components-lib": "static-1.2337",
      "customer-data-objects": "static-1.7405",
      "icons": "static-2.618",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4393",
      "ui-images": "static-2.1081",
      "HeadJS": "static-2.701",
      "framer-motion": "static-1.66",
      "hs-test-utils-bend-plugin": "static-1.2877",
      "msw": "static-1.39",
      "testing-library": "static-1.146",
      "i18n-data": "static-1.216",
      "moment-timezone": "static-5.77",
      "jasmine": "static-4.4092",
      "history": "static-4.47",
      "signup-ui-url-generator": "static-2.7823",
      "HubStyle": "static-2.11491",
      "quartz-i18n": "static-1.351",
      "sassPrefix": "static-1.151",
      "bend-plugin-foundations-components": "static-1.3709",
      "floating-ui": "static-1.50",
      "foundations-theming-specialty": "static-1.1886",
      "hs-story-utils": "static-1.9189",
      "react-virtualized": "static-2.93",
      "tanstack-table": "static-1.49",
      "trellis-assets": "static-1.1086",
      "ui-fonts": "static-1.445",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3697",
      "usage-tracker-anonymous": "static-1.5512",
      "bender-build-tools": "static-1.2899",
      "dispatcher": "static-1.130",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.784",
      "hubspotter-http": "static-1.4443",
      "mobile-manifest-mixins": "static-1.474",
      "quartz-auth": "static-1.351",
      "quartz-head": "static-1.341",
      "quartz-routing": "static-1.106",
      "quartz-test": "static-1.351",
      "usage-tracker-container": "static-1.7085",
      "bend-plugin-foundations-theming": "static-1.2653",
      "foundations-theming-base": "static-1.3155",
      "stylex": "static-1.26",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4410",
      "customer-data-ui-utilities": "static-1.9586",
      "FileManagerCore": "static-1.38268",
      "FileManagerLib": "static-1.38409",
      "hubspot-apollo-client": "static-1.4640",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.520",
      "timezone-utils": "static-2.5005",
      "ui-gdpr-components": "static-1.10108",
      "ts-schema": "static-1.3869",
      "avatar-components": "static-1.2247",
      "content-assistance-lib": "static-1.7388",
      "crm-component-utils": "static-1.38386",
      "crm-display-components": "static-1.24136",
      "crm-fe-perf": "static-1.22668",
      "crm-links": "static-1.6015",
      "crm-message-bus": "static-1.42234",
      "crm-search-service-types": "static-1.914",
      "crm-source-interpretation-lib": "static-1.5093",
      "customer-data-communicator": "static-1.44810",
      "customer-data-filters-ui": "static-1.38738",
      "customer-data-objects-ui-components": "static-1.12764",
      "customer-data-properties": "static-1.50665",
      "customer-data-rte": "static-1.32352",
      "draft-plugins": "static-2.21243",
      "file-manager-components": "static-1.22769",
      "framework-data-schema-resolvers": "static-1.6630",
      "frontend-preferences-client": "static-1.7688",
      "hubspot-prosemirror": "static-1.17493",
      "object-comments-thread-lib": "static-1.9986",
      "reference-resolvers-lite": "static-1.7851",
      "ui-addon-upgrades": "static-9.17592",
      "universal-associations-select": "static-1.10741",
      "ai-components-ui-library": "static-1.8237",
      "final-form": "static-1.64",
      "ui-addon-video-player": "static-1.8456",
      "inbound-db-properties-service-client": "static-1.3641",
      "property-translator": "static-1.5175",
      "hub-http-shared-msw-handlers": "static-1.9382",
      "hubspotter-http-shared-msw-handlers": "static-1.9380",
      "react-dnd-compat": "static-1.4385",
      "audio-components": "static-1.5553",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35920",
      "immerable": "static-1.3916",
      "ui-universal-auth": "static-1.8638",
      "video-components": "static-1.12462",
      "video-data-lib": "static-1.34117",
      "video-embed": "static-1.34951",
      "hubspot-apollo-cache": "static-1.99",
      "superstore": "static-1.4533",
      "ui-coaching-tips": "static-1.27839",
      "card-properties-lib": "static-1.43413",
      "crm-actions": "static-1.6056",
      "crm-cards-data": "static-1.1129",
      "crm-cards-sdk": "static-1.42797",
      "customer-data-properties-shared-msw-handlers": "static-1.8709",
      "customer-data-property-utils": "static-1.7833",
      "customer-data-tracking": "static-1.6643",
      "inbound-db-meta-service-client": "static-1.3397",
      "framework-data-table": "static-2.11324",
      "location-customization-utils-lib": "static-1.8435",
      "calling-error-reporting": "static-1.31059",
      "calling-internal-common": "static-1.31053",
      "calling-usage-tracker": "static-1.6300",
      "crm_data": "static-4.91088",
      "customer-data-content": "static-1.26805",
      "draft-content-plugins": "static-1.27621",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23607",
      "draft-extend": "static-3.69",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.23421",
      "EmailSignatureEditor": "static-1.23859",
      "hubspot-prosemirror-plugins": "static-1.17485",
      "integration-settings-components": "static-1.14692",
      "integrations-lib": "static-1.15289",
      "integrations-tracking-lib": "static-1.5345",
      "native-integrations-shared-strings": "static-1.7550",
      "nav-meta": "static-1.28778",
      "onboarding-scopes": "static-1.6226",
      "outreach-assistant-email-generation": "static-1.5697",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37102",
      "react-colorpicker": "static-2.9973",
      "reference-resolvers": "static-1.7921",
      "rich-text-lib": "static-1.19405",
      "sales-email-signature-service-client": "static-1.3604",
      "sequences-lib": "static-1.7626",
      "ui-addon-i18n": "static-1.10892",
      "ui-addon-iframeable": "static-1.8802",
      "ui-business-units-lib": "static-1.8784",
      "ui-shepherd-react": "static-3.9906",
      "user-context": "static-1.4856",
      "whatsapp-sending-lib": "static-1.4826",
      "customer-data-filters-ui-msw-helpers": "static-1.21172",
      "customer-data-reference-ui-components": "static-1.12902",
      "FormUrlGenerator": "static-2.4492",
      "framework-builder-read-service-client": "static-1.3812",
      "framework-data-schema-quick-fetch": "static-1.6535",
      "multi-account-reference-resolvers": "static-1.730",
      "onboarding-tours": "static-1.16205",
      "reporting-datasets-permissions-lib": "static-1.12930",
      "SharedI18nStrings": "static-1.180",
      "ui-addon-teams": "static-1.21187",
      "calling-global-api": "static-1.63527",
      "calling-lifecycle-internal": "static-1.64909",
      "calling-lifecycle-messages": "static-1.57203",
      "commerce-products-lib": "static-1.8733",
      "conditional-properties-service-client": "static-1.3588",
      "external-options-client-types": "static-1.3948",
      "google-libphonenumber": "static-1.32",
      "hs-entities": "static-1.432",
      "inbounddb-objects-service-types": "static-1.4015",
      "meetings-icalendar-utils-lib": "static-1.395",
      "multi-currency-client-types": "static-1.3483",
      "object-builder-ui-client": "static-1.47841",
      "pipeline-validation-client-types": "static-1.3752",
      "property-value-citations": "static-1.1279",
      "pulse": "static-1.262",
      "smart-property-lib": "static-1.5738",
      "tiered-pricing": "static-1.772",
      "ui-addon-form-validation": "static-1.10756",
      "video-components-external": "static-1.10459",
      "batch-promise": "static-1.1311",
      "crm-pipelines-api-client-types": "static-1.3929",
      "persist-promise": "static-1.3468",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24614",
      "knowledge-content-types": "static-1.8329",
      "payment-link-components": "static-1.22827",
      "ui-addon-emoji-picker": "static-1.9651",
      "call-summary": "static-1.38218",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9528",
      "laboratory-lib": "static-3.6924",
      "merchandise-lib": "static-1.257",
      "purchase-motions-components": "static-1.5427",
      "self-service-api": "static-1.9999",
      "upgrade-management-service-types": "static-1.4269",
      "chatspot-core": "static-1.20153",
      "chirp-fetch": "static-1.1644",
      "ContentUtils": "static-1.67507",
      "copilot-toolkit": "static-1.10422",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "content-icons-ui": "static-1.2140",
      "social-insights-client-types": "static-1.21245",
      "outpost": "static-1.3968",
      "growth-onboarding-feedback-components": "static-1.6346",
      "customer-data-sidebar": "static-2.45307",
      "enrichment-properties-lib": "static-1.14856",
      "customer-data-associations": "static-1.7097",
      "deal-intel-decorators": "static-1.1109",
      "reporting-data": "static-1.66349",
      "tanstack-virtual": "static-1.24",
      "ui-addon-draggable": "static-3.4527",
      "crm-record-cards-service-types": "static-1.3416",
      "crm_universal": "static-1.21595",
      "SalesContentIndexUI": "static-3.8844",
      "signup-ui-lego-core": "static-1.20318",
      "content-embed-lib": "static-1.7102",
      "data-model-builder-lib": "static-1.11543",
      "remote-ui": "static-1.59",
      "ui-components-test-utils": "static-1.5321",
      "ui-extensions-remote-renderer": "static-1.16280",
      "universal-page-editor-lib": "static-1.2760",
      "integrations-error-boundary-lib": "static-1.12704",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10134",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.45276",
      "data-token-picker": "static-1.15979",
      "sequences-client-types-lib": "static-1.7483",
      "foundations-components-test-utils": "static-1.4923",
      "magpie-lib": "static-1.5355",
      "navigation-messaging": "static-1.6468",
      "getting-started-shared-tasks": "static-1.17770",
      "getting-started-shared-tasks-store": "static-1.16888",
      "onboarding-tours-utils": "static-1.271",
      "messaging-usage-based-billing-components-lib": "static-1.401",
      "whatsapp-management-lib": "static-1.7985",
      "growth-data-modal": "static-1.5115",
      "growth-onboarding-confetti": "static-1.2831",
      "growth-onboarding-next-action-utils": "static-1.1256",
      "navigation-components": "static-1.17141",
      "onboarding-tours-client": "static-1.4419",
      "ui-shepherd-tracker": "static-1.7287",
      "shared-worker-versioning": "static-1.10799",
      "voice-sms-access-library": "static-1.121",
      "products-iframe-lib": "static-1.7210",
      "products-ui-components-shared-msw-handlers": "static-1.9764",
      "directed-graph": "static-1.698",
      "event-emitter": "static-1.709",
      "breeze-intelligence-kit": "static-1.5260",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9465",
      "fsm": "static-1.3493",
      "policy-lib": "static-1.6546",
      "react-tinymce": "static-1.54515",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53641",
      "tinymce-plugins": "static-1.56755",
      "tinymce-themes": "static-1.55611",
      "content-media-composition-data-lib": "static-1.11310",
      "content-media-compositions": "static-2.15317",
      "idb-keyval": "static-1.38",
      "magpie-types": "static-1.4815",
      "media-bridge-lib": "static-1.18501",
      "ui-addon-opt": "static-4.8148",
      "commerce-tours-lib": "static-1.5662",
      "growth-onboarding-reliability": "static-1.4850",
      "sales-checkout-service-client": "static-1.3438",
      "ai-addon-copilot-preview": "static-1.7449",
      "calling-cross-tab-library": "static-1.19028",
      "calling-lifecycle-usage-tracker": "static-1.8031",
      "wootric-nps": "static-1.6736",
      "growth-monetization-service-types": "static-1.4285",
      "nav-client-types": "static-1.2117",
      "purchase-motions-api": "static-1.5430",
      "trials-service-types": "static-1.3686",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4568",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2812",
      "card-payment-highlight-lib": "static-1.36395",
      "card-subscription-highlight-lib": "static-1.38750",
      "commerce-billing-lib": "static-1.18388",
      "commerce-contract-lib": "static-1.11019",
      "invoices-highlight-card-lib": "static-1.53880",
      "orders-highlight-card-lib": "static-1.20778",
      "products-highlight-card-lib": "static-1.17017",
      "project-storage": "static-1.4494",
      "quotes-highlight-card-lib": "static-1.71014",
      "usage-based-billing-components-lib": "static-1.7912",
      "deal-intel-utils": "static-1.1113",
      "reporting-client-types": "static-1.2371",
      "react-flip-move": "static-1.64",
      "FireAlarmUi": "static-1.4292",
      "sales-templates-service-types-lib": "static-1.3958",
      "ui-asset-management-lib": "static-1.10657",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9531",
      "collaboration-sidebar": "static-1.57045",
      "conditional-property-settings-modal": "static-1.11854",
      "data-model-commons-lib": "static-1.11837",
      "feedback-loader": "static-1.28777",
      "html-to-image": "static-1.48",
      "object-definition-builder-lib": "static-1.6824",
      "property-management-iframe": "static-1.12160",
      "property-usages-lib": "static-1.5155",
      "reactflow": "static-1.58",
      "simple-data-table": "static-1.2076",
      "used-in-list-lib": "static-1.6679",
      "visual-association": "static-1.5607",
      "highcharts": "static-8.98",
      "reporting-visualizations": "static-1.58425",
      "ui-extensibility-client-types": "static-1.3710",
      "automation-platform-service-types": "static-1.2470",
      "ContentData": "static-1.67582",
      "email-portal-health-service-types": "static-1.738",
      "marketing-email-service-types": "static-1.1770",
      "reactive-lib": "static-1.487",
      "content-whatsapp-service-types": "static-1.236",
      "marketing-platform-lib": "static-1.6595",
      "short-messages-app-service-client": "static-1.3774",
      "ui-tool-access": "static-1.9905",
      "calling-orchestration-schema": "static-1.34898",
      "sales-views-client-types": "static-1.4053",
      "trellis-story-utils": "static-1.4283",
      "storybook-react": "static-1.27",
      "hub-http-contrib": "static-1.2806",
      "interframe": "static-3.4553",
      "tinymce-data": "static-1.39726",
      "ui-addon-sales-email": "static-1.4974",
      "codemirror": "static-5.89",
      "layout-dnd-components": "static-1.11960",
      "layout-dnd-utils": "static-1.10935",
      "react-codemirror": "static-1.10389",
      "ui-brand-identity-lib": "static-1.13675",
      "NamespacedHubStyle": "static-2.8861",
      "hls.js": "static-1.33",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9180",
      "ai-settings-ui-library": "static-1.7319",
      "copilot-plugins": "static-1.10395",
      "eligibility-engine-service-types": "static-1.2967",
      "commerce-shared-components-lib": "static-1.17817",
      "commerce-subscription-lib": "static-1.36327",
      "commerce-tools-ui-lib": "static-1.9696",
      "usage-tracker-session-replay": "static-1.4781",
      "utility-belt": "static-1.2303",
      "payments-enrollment-embed-lib": "static-1.21839",
      "products-ui-components": "static-1.39252",
      "quotes-ui-lib": "static-1.79733",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6664",
      "invoices-ui-lib": "static-1.53896",
      "commerce-products-api": "static-1.1900",
      "SafeStorage": "static-1.4166",
      "invoices-iframe-lib": "static-1.55954",
      "quotes-modal-lib": "static-1.101690",
      "platform-infra-nav-components": "static-1.7457",
      "reporting-ui-components": "static-2.63621",
      "subscription-experience-data-types": "static-1.14535",
      "association-translator": "static-1.2954",
      "crm-settings-header-lib": "static-1.8071",
      "settings-ui-nav": "static-2.9937",
      "chatspot-widget-iframe": "static-1.20145",
      "collaboration-sidebar-common": "static-1.1842",
      "crm-properties-common-lib": "static-1.5633",
      "ui-addon-draggable-compat": "static-2.4015",
      "property-management-common": "static-1.4447",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14757",
      "advanced-menus-lib": "static-1.11740",
      "ExportDialog": "static-6.10149",
      "ui-memberships-settings-lib": "static-1.33323",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9260",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13370",
      "highlight.js": "static-1.73",
      "reporting-action-components": "static-1.40536",
      "reporting-snowflake": "static-1.54967",
      "ui-addon-react-router-dom": "static-1.9309",
      "growth-onboarding-empty-states": "static-1.5303",
      "InboxConnectUtils": "static-4.14123",
      "payments-post-enroll-local-storage-lib": "static-1.4874",
      "qrcode-generator": "static-1.63",
      "amplitude-session-replay-browser": "static-1.54",
      "marketplace-ui-apps-core": "static-1.17378",
      "stripe-embedded-components": "static-1.7068",
      "commerce-permissions": "static-1.513",
      "commerce-tax-lib": "static-1.267",
      "property-description-translator": "static-1.3621",
      "commerce-analytics-service-client": "static-1.3426",
      "totals-ui-components": "static-1.22901",
      "reporting-plugins": "static-1.9932",
      "reporting-reports": "static-1.66027",
      "edison-service-client-types": "static-1.151",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14756",
      "simple-menus-lib": "static-1.16273",
      "academy-common-lib": "static-1.12830",
      "dashboard-lib": "static-1.80454",
      "share-with-third-party-component-lib": "static-1.8451",
      "developer-experience-shared-components": "static-1.10218",
      "marketplace-ui-client-types": "static-1.16252",
      "marketplace-ui-common": "static-1.18845",
      "ui-addon-integrations-directory-panel": "static-2.7746",
      "stripe-connect-js": "static-1.63",
      "commerce-totals-service-types": "static-1.3602",
      "campaign-roi-lib": "static-1.8167",
      "academy-service-client": "static-1.3443",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3640",
      "oauth-service-types": "static-1.4001",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28207",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9438",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4476",
      "atom": "/atom/static-1.4832",
      "conversations-async-data": "/conversations-async-data/static-2.7422",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8638",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15723",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12417",
      "conversations-message-history": "/conversations-message-history/static-1.11916",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10259",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21570",
      "head-dlb": "/head-dlb/static-1.4754",
      "hs-promise-utils": "/hs-promise-utils/static-1.5352",
      "hs-test-utils": "/hs-test-utils/static-1.7766",
      "hubspot-dlb": "/hubspot-dlb/static-2.1796",
      "HubStyleTokens": "/HubStyleTokens/static-2.11183",
      "I18n": "/I18n/static-7.1558",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2780",
      "jasmine-runner": "/jasmine-runner/static-1.6235",
      "quartz": "/quartz/static-1.6676",
      "react-dlb": "/react-dlb/static-1.71",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.59",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4236",
      "StyleGuideUI": "/StyleGuideUI/static-3.483",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4294",
      "usage-tracker": "/usage-tracker/static-1.7095",
      "usage-tracker-core": "/usage-tracker-core/static-1.6945",
      "usage-tracker-public": "/usage-tracker-public/static-1.6906",
      "viral-links-lib": "/viral-links-lib/static-1.6788",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5891",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4572",
      "conversations-prop-types": "/conversations-prop-types/static-1.7212",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20307",
      "cssUtils": "/cssUtils/static-1.720",
      "enviro": "/enviro/static-4.387",
      "flux-actions": "/flux-actions/static-1.302",
      "foundations-components": "/foundations-components/static-1.7440",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5966",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9391",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.349",
      "raven": "/raven/static-3.5624",
      "react": "/react/static-7.177",
      "react-aria": "/react-aria/static-1.60",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.66",
      "react-rhumb": "/react-rhumb/static-1.16402",
      "react-utils": "/react-utils/static-2.5139",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7901",
      "signup-constants": "/signup-constants/static-1.18308",
      "styled-components": "/styled-components/static-2.84",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5509",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5702",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
      "raven-hubspot": "/raven-hubspot/static-1.5931",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3192",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.76",
      "quartz-config": "/quartz-config/static-1.454",
      "quartz-core": "/quartz-core/static-1.5895",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4593",
      "foundations-theming": "/foundations-theming/static-1.4170",
      "UIComponents": "/UIComponents/static-3.8130",
      "customer-data-email": "/customer-data-email/static-1.17601",
      "cv-backend-services": "/cv-backend-services/static-1.1484",
      "immutable-less": "/immutable-less/static-1.4415",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7011",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32315",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2337",
      "customer-data-objects": "/customer-data-objects/static-1.7405",
      "icons": "/icons/static-2.618",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4393",
      "ui-images": "/ui-images/static-2.1081",
      "HeadJS": "/HeadJS/static-2.701",
      "framer-motion": "/framer-motion/static-1.66",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2877",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.146",
      "i18n-data": "/i18n-data/static-1.216",
      "moment-timezone": "/moment-timezone/static-5.77",
      "jasmine": "/jasmine/static-4.4092",
      "history": "/history/static-4.47",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7823",
      "HubStyle": "/HubStyle/static-2.11491",
      "quartz-i18n": "/quartz-i18n/static-1.351",
      "sassPrefix": "/sassPrefix/static-1.151",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3709",
      "floating-ui": "/floating-ui/static-1.50",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1886",
      "hs-story-utils": "/hs-story-utils/static-1.9189",
      "react-virtualized": "/react-virtualized/static-2.93",
      "tanstack-table": "/tanstack-table/static-1.49",
      "trellis-assets": "/trellis-assets/static-1.1086",
      "ui-fonts": "/ui-fonts/static-1.445",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3697",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5512",
      "bender-build-tools": "/bender-build-tools/static-1.2899",
      "dispatcher": "/dispatcher/static-1.130",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.784",
      "hubspotter-http": "/hubspotter-http/static-1.4443",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
      "quartz-auth": "/quartz-auth/static-1.351",
      "quartz-head": "/quartz-head/static-1.341",
      "quartz-routing": "/quartz-routing/static-1.106",
      "quartz-test": "/quartz-test/static-1.351",
      "usage-tracker-container": "/usage-tracker-container/static-1.7085",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2653",
      "foundations-theming-base": "/foundations-theming-base/static-1.3155",
      "stylex": "/stylex/static-1.26",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4410",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9586",
      "FileManagerCore": "/FileManagerCore/static-1.38268",
      "FileManagerLib": "/FileManagerLib/static-1.38409",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4640",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.520",
      "timezone-utils": "/timezone-utils/static-2.5005",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10108",
      "ts-schema": "/ts-schema/static-1.3869",
      "avatar-components": "/avatar-components/static-1.2247",
      "content-assistance-lib": "/content-assistance-lib/static-1.7388",
      "crm-component-utils": "/crm-component-utils/static-1.38386",
      "crm-display-components": "/crm-display-components/static-1.24136",
      "crm-fe-perf": "/crm-fe-perf/static-1.22668",
      "crm-links": "/crm-links/static-1.6015",
      "crm-message-bus": "/crm-message-bus/static-1.42234",
      "crm-search-service-types": "/crm-search-service-types/static-1.914",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5093",
      "customer-data-communicator": "/customer-data-communicator/static-1.44810",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38738",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12764",
      "customer-data-properties": "/customer-data-properties/static-1.50665",
      "customer-data-rte": "/customer-data-rte/static-1.32352",
      "draft-plugins": "/draft-plugins/static-2.21243",
      "file-manager-components": "/file-manager-components/static-1.22769",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6630",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7688",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17493",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9986",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7851",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17592",
      "universal-associations-select": "/universal-associations-select/static-1.10741",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8237",
      "final-form": "/final-form/static-1.64",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8456",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3641",
      "property-translator": "/property-translator/static-1.5175",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9382",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9380",
      "react-dnd-compat": "/react-dnd-compat/static-1.4385",
      "audio-components": "/audio-components/static-1.5553",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35920",
      "immerable": "/immerable/static-1.3916",
      "ui-universal-auth": "/ui-universal-auth/static-1.8638",
      "video-components": "/video-components/static-1.12462",
      "video-data-lib": "/video-data-lib/static-1.34117",
      "video-embed": "/video-embed/static-1.34951",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.99",
      "superstore": "/superstore/static-1.4533",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27839",
      "card-properties-lib": "/card-properties-lib/static-1.43413",
      "crm-actions": "/crm-actions/static-1.6056",
      "crm-cards-data": "/crm-cards-data/static-1.1129",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42797",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8709",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7833",
      "customer-data-tracking": "/customer-data-tracking/static-1.6643",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
      "framework-data-table": "/framework-data-table/static-2.11324",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8435",
      "calling-error-reporting": "/calling-error-reporting/static-1.31059",
      "calling-internal-common": "/calling-internal-common/static-1.31053",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6300",
      "crm_data": "/crm_data/static-4.91088",
      "customer-data-content": "/customer-data-content/static-1.26805",
      "draft-content-plugins": "/draft-content-plugins/static-1.27621",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23607",
      "draft-extend": "/draft-extend/static-3.69",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23421",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17485",
      "integration-settings-components": "/integration-settings-components/static-1.14692",
      "integrations-lib": "/integrations-lib/static-1.15289",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5345",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7550",
      "nav-meta": "/nav-meta/static-1.28778",
      "onboarding-scopes": "/onboarding-scopes/static-1.6226",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5697",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37102",
      "react-colorpicker": "/react-colorpicker/static-2.9973",
      "reference-resolvers": "/reference-resolvers/static-1.7921",
      "rich-text-lib": "/rich-text-lib/static-1.19405",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3604",
      "sequences-lib": "/sequences-lib/static-1.7626",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10892",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8802",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8784",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9906",
      "user-context": "/user-context/static-1.4856",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4826",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21172",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12902",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4492",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3812",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6535",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.730",
      "onboarding-tours": "/onboarding-tours/static-1.16205",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12930",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
      "ui-addon-teams": "/ui-addon-teams/static-1.21187",
      "calling-global-api": "/calling-global-api/static-1.63527",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64909",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57203",
      "commerce-products-lib": "/commerce-products-lib/static-1.8733",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3588",
      "external-options-client-types": "/external-options-client-types/static-1.3948",
      "google-libphonenumber": "/google-libphonenumber/static-1.32",
      "hs-entities": "/hs-entities/static-1.432",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4015",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.395",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3483",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47841",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3752",
      "property-value-citations": "/property-value-citations/static-1.1279",
      "pulse": "/pulse/static-1.262",
      "smart-property-lib": "/smart-property-lib/static-1.5738",
      "tiered-pricing": "/tiered-pricing/static-1.772",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10756",
      "video-components-external": "/video-components-external/static-1.10459",
      "batch-promise": "/batch-promise/static-1.1311",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3929",
      "persist-promise": "/persist-promise/static-1.3468",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24614",
      "knowledge-content-types": "/knowledge-content-types/static-1.8329",
      "payment-link-components": "/payment-link-components/static-1.22827",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9651",
      "call-summary": "/call-summary/static-1.38218",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9528",
      "laboratory-lib": "/laboratory-lib/static-3.6924",
      "merchandise-lib": "/merchandise-lib/static-1.257",
      "purchase-motions-components": "/purchase-motions-components/static-1.5427",
      "self-service-api": "/self-service-api/static-1.9999",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4269",
      "chatspot-core": "/chatspot-core/static-1.20153",
      "chirp-fetch": "/chirp-fetch/static-1.1644",
      "ContentUtils": "/ContentUtils/static-1.67507",
      "copilot-toolkit": "/copilot-toolkit/static-1.10422",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "content-icons-ui": "/content-icons-ui/static-1.2140",
      "social-insights-client-types": "/social-insights-client-types/static-1.21245",
      "outpost": "/outpost/static-1.3968",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6346",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45307",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14856",
      "customer-data-associations": "/customer-data-associations/static-1.7097",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1109",
      "reporting-data": "/reporting-data/static-1.66349",
      "tanstack-virtual": "/tanstack-virtual/static-1.24",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4527",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3416",
      "crm_universal": "/crm_universal/static-1.21595",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8844",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20318",
      "content-embed-lib": "/content-embed-lib/static-1.7102",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11543",
      "remote-ui": "/remote-ui/static-1.59",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5321",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16280",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2760",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12704",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10134",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.45276",
      "data-token-picker": "/data-token-picker/static-1.15979",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7483",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4923",
      "magpie-lib": "/magpie-lib/static-1.5355",
      "navigation-messaging": "/navigation-messaging/static-1.6468",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17770",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16888",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.271",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.401",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7985",
      "growth-data-modal": "/growth-data-modal/static-1.5115",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2831",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1256",
      "navigation-components": "/navigation-components/static-1.17141",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4419",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7287",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10799",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.121",
      "products-iframe-lib": "/products-iframe-lib/static-1.7210",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9764",
      "directed-graph": "/directed-graph/static-1.698",
      "event-emitter": "/event-emitter/static-1.709",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5260",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9465",
      "fsm": "/fsm/static-1.3493",
      "policy-lib": "/policy-lib/static-1.6546",
      "react-tinymce": "/react-tinymce/static-1.54515",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53641",
      "tinymce-plugins": "/tinymce-plugins/static-1.56755",
      "tinymce-themes": "/tinymce-themes/static-1.55611",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11310",
      "content-media-compositions": "/content-media-compositions/static-2.15317",
      "idb-keyval": "/idb-keyval/static-1.38",
      "magpie-types": "/magpie-types/static-1.4815",
      "media-bridge-lib": "/media-bridge-lib/static-1.18501",
      "ui-addon-opt": "/ui-addon-opt/static-4.8148",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5662",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4850",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3438",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7449",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19028",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8031",
      "wootric-nps": "/wootric-nps/static-1.6736",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4285",
      "nav-client-types": "/nav-client-types/static-1.2117",
      "purchase-motions-api": "/purchase-motions-api/static-1.5430",
      "trials-service-types": "/trials-service-types/static-1.3686",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4568",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2812",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36395",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38750",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18388",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11019",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53880",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20778",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17017",
      "project-storage": "/project-storage/static-1.4494",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71014",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7912",
      "deal-intel-utils": "/deal-intel-utils/static-1.1113",
      "reporting-client-types": "/reporting-client-types/static-1.2371",
      "react-flip-move": "/react-flip-move/static-1.64",
      "FireAlarmUi": "/FireAlarmUi/static-1.4292",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3958",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10657",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9531",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57045",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11854",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11837",
      "feedback-loader": "/feedback-loader/static-1.28777",
      "html-to-image": "/html-to-image/static-1.48",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6824",
      "property-management-iframe": "/property-management-iframe/static-1.12160",
      "property-usages-lib": "/property-usages-lib/static-1.5155",
      "reactflow": "/reactflow/static-1.58",
      "simple-data-table": "/simple-data-table/static-1.2076",
      "used-in-list-lib": "/used-in-list-lib/static-1.6679",
      "visual-association": "/visual-association/static-1.5607",
      "highcharts": "/highcharts/static-8.98",
      "reporting-visualizations": "/reporting-visualizations/static-1.58425",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3710",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2470",
      "ContentData": "/ContentData/static-1.67582",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.738",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1770",
      "reactive-lib": "/reactive-lib/static-1.487",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.236",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6595",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3774",
      "ui-tool-access": "/ui-tool-access/static-1.9905",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34898",
      "sales-views-client-types": "/sales-views-client-types/static-1.4053",
      "trellis-story-utils": "/trellis-story-utils/static-1.4283",
      "storybook-react": "/storybook-react/static-1.27",
      "hub-http-contrib": "/hub-http-contrib/static-1.2806",
      "interframe": "/interframe/static-3.4553",
      "tinymce-data": "/tinymce-data/static-1.39726",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4974",
      "codemirror": "/codemirror/static-5.89",
      "layout-dnd-components": "/layout-dnd-components/static-1.11960",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10935",
      "react-codemirror": "/react-codemirror/static-1.10389",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13675",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8861",
      "hls.js": "/hls.js/static-1.33",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9180",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7319",
      "copilot-plugins": "/copilot-plugins/static-1.10395",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2967",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17817",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36327",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9696",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4781",
      "utility-belt": "/utility-belt/static-1.2303",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21839",
      "products-ui-components": "/products-ui-components/static-1.39252",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79733",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6664",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53896",
      "commerce-products-api": "/commerce-products-api/static-1.1900",
      "SafeStorage": "/SafeStorage/static-1.4166",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55954",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101690",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7457",
      "reporting-ui-components": "/reporting-ui-components/static-2.63621",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14535",
      "association-translator": "/association-translator/static-1.2954",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8071",
      "settings-ui-nav": "/settings-ui-nav/static-2.9937",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20145",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1842",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5633",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4015",
      "property-management-common": "/property-management-common/static-1.4447",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14757",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11740",
      "ExportDialog": "/ExportDialog/static-6.10149",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33323",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9260",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13370",
      "highlight.js": "/highlight.js/static-1.73",
      "reporting-action-components": "/reporting-action-components/static-1.40536",
      "reporting-snowflake": "/reporting-snowflake/static-1.54967",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9309",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5303",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14123",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4874",
      "qrcode-generator": "/qrcode-generator/static-1.63",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17378",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7068",
      "commerce-permissions": "/commerce-permissions/static-1.513",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.267",
      "property-description-translator": "/property-description-translator/static-1.3621",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3426",
      "totals-ui-components": "/totals-ui-components/static-1.22901",
      "reporting-plugins": "/reporting-plugins/static-1.9932",
      "reporting-reports": "/reporting-reports/static-1.66027",
      "edison-service-client-types": "/edison-service-client-types/static-1.151",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14756",
      "simple-menus-lib": "/simple-menus-lib/static-1.16273",
      "academy-common-lib": "/academy-common-lib/static-1.12830",
      "dashboard-lib": "/dashboard-lib/static-1.80454",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8451",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10218",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16252",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18845",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7746",
      "stripe-connect-js": "/stripe-connect-js/static-1.63",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3602",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8167",
      "academy-service-client": "/academy-service-client/static-1.3443",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3640",
      "oauth-service-types": "/oauth-service-types/static-1.4001",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};